import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@crisp/crisp-ui/icons/classic/regular';
import { cn } from '../../lib/cn';
import styles from './PrevNextNav.module.css';

interface NavTarget {
  slug: string;
  title: string;
}

interface PrevNextNavProps {
  prev?: NavTarget | null;
  next?: NavTarget | null;
  routePrefix?: string;
}

export const PrevNextNav: React.FC<PrevNextNavProps> = ({ prev, next, routePrefix = '' }) => {
  if (!prev && !next) return null;

  return (
    <div className={styles.nav}>
      {prev ? (
        <Link
          to={`${routePrefix}${prev.slug === 'index' ? '' : `/${prev.slug}`}` || '/'}
          className={styles.card}
        >
          <div className={styles.direction}>
            <FontAwesomeIcon icon={faChevronLeft} className="icon-slot" />
            <span>Previous</span>
          </div>
          <span className={styles.title}>{prev.title}</span>
        </Link>
      ) : (
        <div className={styles.spacer} />
      )}

      {next ? (
        <Link
          to={`${routePrefix}${next.slug === 'index' ? '' : `/${next.slug}`}` || '/'}
          className={cn(styles.card, styles.cardNext)}
        >
          <div className={styles.direction}>
            <span>Next</span>
            <FontAwesomeIcon icon={faChevronRight} className="icon-slot" />
          </div>
          <span className={styles.title}>{next.title}</span>
        </Link>
      ) : (
        <div className={styles.spacer} />
      )}
    </div>
  );
};

export default PrevNextNav;
